import React from 'react';
import { Spin, Button, Input } from 'antd';
import TableC from '../basicElement/TableC';
import ExportUtil from '../../common/ExportUtil';
import $ from '../../common/AjaxRequest';
import API_URL from '../../common/url';
import cf from '../../utils/cf';
import fp from '../../utils/fp';

class SiteList extends React.Component {
    state = {
        sortParams: {},
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        loading: false,
        dataList: [],
        tableheader: [],
    }

    componentDidMount() {
        this.getheader();
    }

    getheader = () => {      //拿表头      
        const { selInvId } = this.props.match.params;
        const options = {
            method: 'POST',
            url: API_URL.investigation.getSiteHeader,
            data: {
                investigationId:selInvId,
            },
            dataType: 'json',
            doneResult: data => {
                const { headerList } = data.data;
                this.setState({
                    tableheader: headerList,                        
                }, () => {
                    this.loadData();
                });
            }
        };
        $.sendRequest(options);
    }

    loadData = () => {
        const { sortParams, searchParams, pagination, pagination: { current, pageSize } } = this.state;
        const { selRole, selInvId } = this.props.match.params;
        this.setState({loading: true,});
        const options = {
            url: `${API_URL.site.querySiteDetailList}`,
            data: {
                offset: current,
                limit: pageSize,
                investigationId: selInvId,
                roleCode: selRole,
                ...searchParams,
                ...sortParams,
                transFlag: 1,
            },
            dataType: 'json',
            doneResult: ( data => {
                    const { invSite } = data.data;
                    pagination.total = invSite.totalCount;
                    this.setState({
                        pagination,
                        loading: false,
                        dataList: invSite.datas,
                    });
                }
            ),
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { selRole, selInvId } = this.props.match.params;
        const { sortParams, searchParams } = this.state;
        const url = API_URL.site.exportSiteDetailList;
        ExportUtil.export({
            ...sortParams,
            ...searchParams,
            transFlag: 1,
            roleCode: selRole,
            investigationId: selInvId,
        }, null, url);
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    getColumns = () => {
        const {tableheader} = this.state;
        const columnNames = [];
        columnNames.push({
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 60,
        });
        columnNames.push({
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            sorter: true,
            fixed: 'left',
            width: 100,
            render: (text, record) => {
                const { allowedEnter, investigationSiteId, investigationSiteName, investigationSiteCode } = record;
                return (
                    <span>
                        {
                            allowedEnter ?
                                <a onClick={() => this.selectSite(investigationSiteId, investigationSiteName, investigationSiteCode)}>{investigationSiteCode}</a>
                            :
                                investigationSiteCode
                        }
                    </span>
                );
            },
        });
        columnNames.push({
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            sorter: true,
            fixed: 'left',
            width: 200,
        });

        tableheader.map((d,i)=>{
            if(i>1){
                if(d.type == 'STATISTIC' || d.type == 'PLAN'){
                    columnNames.push({
                        title: d.displayName,
                        dataIndex: d.field + d.type,
                        key: d.field + d.type,
                        sorter: d.sortable,
                        sortType: d.type,
                        sort : d.field,
                        width: 110,
                    })
                } else {
                    columnNames.push({
                        title: d.displayName,
                        dataIndex: d.field,
                        key: d.field,
                        sorter: d.sortable,
                        sortType: d.type,
                        sort : d.field,
                        width: 110,
                    })
                }
            }
        });
        return columnNames;
    }

    getDataSource = () => {
        const { dataList, tableheader, pagination: { current, pageSize } } = this.state;
        let headers = tableheader;
        let invList = dataList;
        const dataSource = invList.map((inv, i) => {
            let row = {index: (current - 1) * pageSize + i + 1, investigationId: inv.investigationId, investigationSiteId: inv.investigationSiteId, allowedEnter: inv.allowedEnter}; 
            headers.map((header, j) =>{
                let value; 
                let field = header.field;
                if(header.type == 'STATISTIC' || header.type == 'PLAN'){
                    field = field + header.type;
                }
                inv.fields.map((invField, k) => {
                    if(invField.field == header.field){
                        value = invField.value;
                    }
                });
                inv.planFields.map((invField,k) => {
                    if(invField.field == header.field 
                    && invField.type == header.type){
                        value = invField.value;
                    }
                });
                inv.roleFields.map((invField,k) => {
                    if(invField.field == header.field){
                        value = invField.value;
                    }
                });
                inv.executeFields.map((invField,k) => {
                    if(invField.field == header.field){
                        value = invField.value;
                    }
                });
                row[field] = value;
            });
            return row;
        });
        return dataSource;
    }

    /**
     * 点击“中心汇总”按钮
     */
    clickSiteSummary = () => {
        const { selRole, selInvId } = this.props.match.params;
        sessionStorage.invId = selInvId;
        sessionStorage.curRole = selRole;
        sessionStorage.investigationSiteName = '中心汇总';
        location.href = `./#/summary/siteStart/Project_Approval`;
    };

    /**
     * 点击某个项目时，获取角色列表，判断是单角色还是多角色
     */
    selectSite = (investigationSiteId, investigationSiteName, investigationSiteCode) => {
        const { selRole, selInvId } = this.props.match.params;

        sessionStorage.invId = selInvId;
        sessionStorage.siteId = investigationSiteId;
        sessionStorage.curRole = selRole;
        sessionStorage.investigationSiteCode = investigationSiteCode;
        sessionStorage.investigationSiteName = investigationSiteName;
        location.href = `./#/summary/view/cumInfRan`;
    }

    handleInputChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value;
        this.setState({ searchParams });
    }
  
    render() {
        const { loading, pagination } = this.state;
        const { selRole } = this.props.match.params;
        const hasSiteSummary = fp.contains(selRole)(['PM', 'PA', 'CRCM', 'BO', 'BD', 'TAL', 'BDO', 'BDM', 'CTA', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL' ])
        return (
            <div className="content-2 full">
                <div className='filter-bar'>
                    {
                        hasSiteSummary && <Button type="primary" onClick={this.clickSiteSummary}>中心汇总</Button>
                    }
                    <div className="form-item">
                        <label className="ui-label">中心编号</label>
                        <Input
                            placeholder="请输入"
                            onChange={e => this.handleInputChange(e, 'siteCode')}
                        />
                    </div>
                    <div className="form-item">
                        <label className="ui-label"> 中心名称</label>
                        <Input
                            placeholder="请输入"
                            onChange={e => this.handleInputChange(e, 'siteName')}
                        />
                    </div>
                    <div className="form-item">
                        <label className="ui-label"> JDE项目号</label>
                        <Input
                            placeholder="请输入"
                            onChange={e => this.handleInputChange(e, 'investigationJdeContractCode')}
                        />
                    </div>
                    <div className="form-item">
                        <Button type="primary" onClick={this.export}>导出</Button>
                        <Button type="primary" onClick={this.search}>搜索</Button>
                    </div>
                </div>
                <div className="main-content">
                    <Spin spinning={loading}>
                        <TableC
                            className="siteList"
                            columns={this.getColumns()}                            
                            data={this.getDataSource()}
                            rowKey="investigationSiteId"
                            onChange={this.handleTableChange}
                            pagination={pagination}
                        />
                    </Spin>
                </div>
            </div>
        );
    }
}

export default SiteList;


// WEBPACK FOOTER //
// ./src/components/investigation/SiteList.js